import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

// Busqueda de la cantidad de personas con documentos pendientes
export const findTotalPeople = createAsyncThunk(
  "massNotifications/findTotalPeople",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const documentsTypes = state.massNotification.selectedDocumentTypes;
      const createdAtFilter = state.massNotification.createdAtFilter;
      const idsDocumentsTypes = documentsTypes.map((documentType) => documentType.id);
      const { data } = await axiosInstance.post(
        `${api.baseURL}document/count-pending-document-type-detail`,
        {
          idDocumentType: idsDocumentsTypes,
          organization: state.userAuthentication.user?.sourceOrganization,
          startDate: createdAtFilter?.from ? createdAtFilter?.from : null,
          endDate: createdAtFilter?.to ? createdAtFilter?.to : null,
        }
      );
      return data.totalPeople;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
